import api from './api';

export const homepageService = {
  getStatistics: async () => {
    const response = await api.get('/exgratia-report/statistics/homepage');
    return response.data;
  },
};

export default homepageService;